<div class="welcome-page-sys-admin">
    <div class="welcome-page-sys-admin__container">
        <img src="/assets/images/sys_admin_welcome.svg" alt="">

        <span [innerHTML]="'SysAdmin.Welcome' | translate">
        </span>
    </div>
</div>